import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'distribution-wizard',
    templateUrl: './distribution-wizard.html',
    styleUrls: ['./distribution-wizard.less'],
    standalone: false
})
export class DistributionWizard implements OnInit {
	@Input() sendReportStatus: number = 1;
	constructor(){
	}
	ngOnInit(): void {}
}
